// extracted by mini-css-extract-plugin
module.exports = {"header-wrap":"EMBAGGlobalHeader_header-wrap__Q0Fiz","embag":"EMBAGGlobalHeader_embag__h2SyI"};